import { render, staticRenderFns } from "./subscriptionPlanCard.vue?vue&type=template&id=048d0f48&"
import script from "./subscriptionPlanCard.vue?vue&type=script&lang=js&"
export * from "./subscriptionPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports